import Accordion, { AccordionItem } from '@repo/ui/src/components/Accordion';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import { Anchor, AnchorProps } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

interface Props {
  columns: Array<{
    links?: Array<AnchorProps>;
    title: string;
  }>;
  className?: string;
}

const MobileAccordion = ({ columns, className }: Props) => {
  return (
    <Accordion dark className={className} allowMultipleExpanded allowZeroExpanded>
      {columns?.map((col) => (
        <AccordionItem
          key={col.title}
          heading={col.title}
          headerClassName="tw-border-b tw-border-neutral-300 tra-text-web-sub-2 tw-items-center tw-py-2 [&_svg]:tw-text-[#747778]"
        >
          {col?.links?.map((link) => (
            <li
              className="tw-pl-4"
              key={link?.displayName}
              onChange={() =>
                navigationClicked({
                  nav_type: 'Footer Navigation',
                  clicked_text: link?.displayName,
                  primary_header: col.title,
                })
              }
            >
              <Anchor
                className={classNames(
                  'tra-text-web-body-s tw-text-neutral-200 tw-block tw-py-2 tw-outline-offset-2',
                  'focus:tw-outline-brand-200 focus:tw-outline-2 focus-visible:tw-outline',
                  'hover:tw-underline hover:tw-text-brand-200',
                )}
                {...link}
              >
                {link?.displayName}
              </Anchor>
            </li>
          ))}
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default MobileAccordion;
